import { Component, inject } from "@angular/core";
import { MessageService } from "./message.service";

@Component({
  standalone: false,
  selector: 'app-message',
  templateUrl: './message.component.html'
})
export class MessageComponent {
  private readonly messageService = inject(MessageService);

  readonly currentMessage = this.messageService.currentMessage;

  hideMessage(): void {
    this.messageService.hideMessage();
  }
}
